var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8685 2.86902C11.4934 2.24418 12.5064 2.24418 13.1313 2.86902C13.7561 3.49386 13.7561 4.50692 13.1313 5.13176L12.497 5.76608L10.2342 3.50333L10.8685 2.86902Z",
    fill: "url(#paint0_linear_258_4196)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10285 4.63471L2.3999 11.3376V13.6004H4.66264L11.3656 6.89745L9.10285 4.63471Z",
    fill: "url(#paint1_linear_258_4196)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_4196",
    x1: 2.3999,
    y1: 2.40039,
    x2: 13.5999,
    y2: 13.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2375D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_4196",
    x1: 2.3999,
    y1: 2.40039,
    x2: 13.5999,
    y2: 13.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2375D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3B65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.dd7c4339d3321cbc73fcfd77ef735e88.svg";
export { ForwardRef as ReactComponent };